module.exports = __webpack_public_path__ + "img/图片28.f405202e.png";